import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changeOrderOption'
})
export class ChangeOrderOptionPipe implements PipeTransform {

  transform(value: string, ...args: string[]): string {
    return value ? 'Aceptar en Rest.' : 'Asignar Repartidor'  ;
  }

}
